import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

import SocialMediaLink from './SocialMediaLink';

import { ISocialMediaLinkList } from 'source/NFR.types';

const themes = defineTheme({
  white: 'social-media-link-list--theme-white'
});
type Theme = ThemeKeys<typeof themes>;

interface ISocialMediaLinkListProps extends ISocialMediaLinkList {
  className?: string;
  theme?: Theme;
}

const SocialMediaLinkList: React.FC<ISocialMediaLinkListProps> = ({ className, items = [], theme }) =>
  items.length > 0 && (
    <div className={cn('social-media-link-list', themes(theme), className)}>
      {items?.map(link => (
        <SocialMediaLink key={link.url} {...link} />
      ))}
    </div>
  );

SocialMediaLinkList.displayName = 'SocialMediaLinkList';

export default SocialMediaLinkList;
